import { render, staticRenderFns } from "./fp.vue?vue&type=template&id=cd8213c0"
import script from "./fp.vue?vue&type=script&lang=js"
export * from "./fp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports